"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
function isCompanyLimit(object) {
    return checkCompanyLimit(object).fulfilled;
}
exports.isCompanyLimit = isCompanyLimit;
function checkCompanyLimit(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return __1.check(object, __1.hasString("companyId"), __1.hasNumber("storageGBytes")).withOptions(options).explain();
}
exports.checkCompanyLimit = checkCompanyLimit;
//# sourceMappingURL=CompanyLimit.js.map